import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import VoucherAd from '../components/voucher-ad'
import ContactForm from '../components/ContactForm'
import Map from '../components/Map'
import config from '../../data/siteConfig'

const AddressData = ({large}) => {
  return (
    <div className='address-text'>
      <h4>Site address</h4>
      <p>{config.siteName}</p>
      <p dangerouslySetInnerHTML={{__html: config.siteAddress}} />
      <h4>Office address only</h4>
      <p>{config.siteName}</p>
      <p dangerouslySetInnerHTML={{__html: config.siteOfficeAddress}} />
    </div>
  )
}

const ContactPage = () => (
  <span>
    <Helmet
      title={`${config.siteName} | Contact | ${config.siteTitleAlt}`}
      meta={[
        {
          name: 'description',
          content: `Our team are on hand to help you plan your 4 x4 off roading experience day. Email: ${config.siteEmail} or call us on ${config.sitePhone}`
        }
      ]}
    />
    <div className="contact banner">
      <div className="banner-info top-off-center text-center">
        <h2 className="uppercase">Unsure or have a question? <br/>We are here to help</h2>
        <span className="spacer white hide-for-small-only">―</span>
        <h5 className="highlight hide-for-small-only"><span>Phone: {config.sitePhone}</span></h5>
        <h5 className="highlight hide-for-small-only"><span>Email: <a href={`mailto:${config.siteEmail}`}>{config.siteEmail}</a></span></h5>
      </div>
    </div>
    <main>
      <section className="row">
        <div className="small-12 medium-10 columns">
          <div className="content-header">
            <h1 className="uppercase">Contact</h1>
          </div>
        </div>
      </section>
      <section className="row">
        <div className="large-9 columns">
          <h3 className="subheader">There are many ways to contact us at {config.siteName}</h3>
          <p>The easiest way to contact us is via our online form. If your query is urgent then why not call us on {config.sitePhone}</p>
          <p>You can also get us on social media by sending a message on <a href="https://www.facebook.com/4x4DrivingSchool">Facebook</a> or <a href="https://twitter.com/School4x4">Twitter</a></p>
          <div className="form-container">
            <ContactForm />
          </div>
          <h3 className="subheader">How to find us</h3>
          <p>We are based in North Cardiff just off the M4 J32 (Coryton) (4mins). Taffs Well train station is just at the bottom of the hill. We are easy to find no matter where u are travelling from</p>
        </div>
      </section>
    </main>
    <section>
      <div className="address-container">
        <Map
          isMarkerShown
          googleMapURL='https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places'
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={<div className="map-container" />}
          mapElement={<div style={{ height: `100%` }} />}
        />
      </div>
      <div className="row">
        <div className="medium-5 large-3 hide-for-small-only columns">
          <AddressData />
        </div>
      </div>
    </section>
    <section className='hide-for-medium'>
      <div className="row">
        <div className="small-12 columns">
          <AddressData />
        </div>
      </div>
    </section>
  </span>
)

export default ContactPage



// WEBPACK FOOTER //
// ./src/pages/contact.js